<template>
    <div class="wrapper">
      <Topbar />
      <Sidebar />
      <main class="content-page">
        <router-view :key="routeKey"></router-view>
        <FooterBar />
      </main>
    </div>
  </template>
  
<script>
import Topbar from '@/components/topbar.vue';
import Sidebar from '@/components/sidebar.vue';
import FooterBar from '@/components/footer.vue';
import ThemeCustomizer from '@/assets/js/app.js'

export default {
  name: 'HomePage',
  components: {
    Topbar,
    Sidebar,
    FooterBar,
  },
  computed: {
    routeKey() {
      if (this.$route.path.startsWith('/component-edit-reader')) {
        return this.$route.query.position;
      }
      if (this.$route.path.startsWith('/component-edit-scenario')) {
        return this.$route.query.id;
      }
      return null;
    }
  }, 
  mounted() {
    const themeCustomizer = new ThemeCustomizer();
    themeCustomizer.init();
  },
};
</script>
